import React from 'react';

import './PartnersSalons.scss';
import PartnersCards_img_1 from '../../../assets/img/llc/llc_partner.svg'

class PartnersSalons extends React.PureComponent {
  render() {
    return (
      <section className="partnersSalons">
        <div className="container">
          <h6 className="text-center">Kosmetické salony a jiná <br/> nezdravotnická zařízení:</h6>
          <div className="row">
            <div className="col-6 partnersCards_item_col">
              <div className="partnersCards_item">
                <div className="partnersCards_item_img"><img src={PartnersCards_img_1}/></div>
                <div className="partnersCards_item_text">
                  <div className="partnersCards_item_title">Studio ANDREA</div>
                  <div className="partnersCards_item_name">Andrea Habrnálová</div>
                  <div className="partnersCards_item_desc">
                    Lesní 581<br/>
                    739 61 Třinec <br/>
                    <strong>tel.</strong> +420 603 293 082<br/>
                    <a href="http://www.studioandrea.com/" target="_blank">www.studioandrea.com</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 partnersCards_item_col">
              <div className="partnersCards_item">
                <div className="partnersCards_item_img"><img src={PartnersCards_img_1}/></div>
                <div className="partnersCards_item_text">
                  <div className="partnersCards_item_title">Z- studio - kosmetický salón</div>
                  <div className="partnersCards_item_name">Zdena Hurtuková <br/> Eva Navrátilová</div>
                  <div className="partnersCards_item_desc">
                    Stodolní 2 <br/>
                    701 00 Moravská Ostrava<br/>
                    <strong>tel.</strong> +420 603 970 306<br/>
                    <strong>tel.</strong> +420 608 410 474
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 partnersCards_item_col">
              <div className="partnersCards_item">
                <div className="partnersCards_item_img"><img src={PartnersCards_img_1}/></div>
                <div className="partnersCards_item_text">
                  <div className="partnersCards_item_title">WELLNESS STUDIO IVA</div>
                  <div className="partnersCards_item_name">Iva Endalová</div>
                  <div className="partnersCards_item_desc">
                    Masarykova 2 <br/>
                    701 00 Moravská Ostrava<br/>
                    <strong>tel.</strong> +420 603 810 210<br/>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 partnersCards_item_col">
              <div className="partnersCards_item">
                <div className="partnersCards_item_img"><img src={PartnersCards_img_1}/></div>
                <div className="partnersCards_item_text">
                  <div className="partnersCards_item_title">Beauty centrum</div>
                  <div className="partnersCards_item_name">Slávka Ameirová</div>
                  <div className="partnersCards_item_desc">
                    Čs. Legií 4 <br/>
                    Ostrava <br/>
                    <strong>tel.</strong> +420 602 228 599 <br/>
                    <strong>tel.</strong> +420 776 028 599
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 partnersCards_item_col">
              <div className="partnersCards_item">
                <div className="partnersCards_item_img"><img src={PartnersCards_img_1}/></div>
                <div className="partnersCards_item_text">
                  <div className="partnersCards_item_title">Turtáková Jana - kosmetika</div>
                  <div className="partnersCards_item_name">Turtáková Jana</div>
                  <div className="partnersCards_item_desc">
                    Jarní 2 <br/>
                    Šternberk <br/>
                    <strong>tel.</strong> +420 608 861 616
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 partnersCards_item_col">
              <div className="partnersCards_item">
                <div className="partnersCards_item_img"><img src={PartnersCards_img_1}/></div>
                <div className="partnersCards_item_text">
                  <div className="partnersCards_item_title">Kosmetika Mgr. Jana Fišerová</div>
                  <div className="partnersCards_item_name">
                    Dům s pečovatelskou službou naproti hlavní pošty
                  </div>
                  <div className="partnersCards_item_desc">
                    Sadová 606, 4. patro <br/>
                    738 01 Frýdek - Místek <br/>
                    <strong>tel.</strong> +420 558 623 384 <br/>
                    <strong>tel.</strong> +420 603 770 115 <br/>
                    <strong>E-mail</strong> <a href="mailto:fiserovaF-M@post.cz">fiserovaF-M@post.cz</a> <br/>
                    <a href="http://kosmetika-frydecko.mistecko.cz/"
                       target="_blank">www.kosmetika-frydecko.mistecko.cz</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 partnersCards_item_col">
              <div className="partnersCards_item">
                <div className="partnersCards_item_img"><img src={PartnersCards_img_1}/></div>
                <div className="partnersCards_item_text">
                  <div className="partnersCards_item_title">TOP FITNESS</div>
                  <div className="partnersCards_item_name">obchodní dům FUTURUM</div>
                  <div className="partnersCards_item_desc">
                    Varenská ulice <br/>
                    709 00 Ostrava <br/>
                    <strong>tel.</strong> +420 596 633 621 <br/>
                    <strong>E-mail</strong> <a href="mailto:futurum@topfitness.cz">futurum@topfitness.cz</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 partnersCards_item_col">
              <div className="partnersCards_item">
                <div className="partnersCards_item_img"><img src={PartnersCards_img_1}/></div>
                <div className="partnersCards_item_text">
                  <div className="partnersCards_item_title">Studio Chic</div>
                  <div className="partnersCards_item_name">Ivana Češková</div>
                  <div className="partnersCards_item_desc">
                    Solná 13 Opava, propagační podnik <br/>
                    1. patro <br/>
                    tel. 774 500 390 <br/>
                    <strong>E-mail</strong> <a href="mailto:ceskova.ivana@seznam.cz">ceskova.ivana@seznam.cz</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 partnersCards_item_col">
              <div className="partnersCards_item">
                <div className="partnersCards_item_img"><img src={PartnersCards_img_1}/></div>
                <div className="partnersCards_item_text">
                  <div className="partnersCards_item_title">Kosmetický salon Popelka</div>
                  <div className="partnersCards_item_name">Veronika Pěcháčková</div>
                  <div className="partnersCards_item_desc">
                    17. listopadu 538, budova E <br/>
                    Bílovec <br/>
                    Tel. 732 965 359 <br/>
                    <a href="https://www.facebook.com/pg/kosmetikapopelka/services/?ref=page_internal"
                       target="_blank">
                      Facebook - Kosmetický salon Popelka
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );

  }
}

export default PartnersSalons;



// WEBPACK FOOTER //
// ./src/components/Partners/PartnersSalons/PartnersSalons.js